import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { SoporteHCContent } from './SoporteHCContent';

export default function SoporteHC() {
    return (
        <>
            <MainContent
                component={<SoporteHCContent />}
                titulo='Soporte HC'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
